export const PLANS = {
  STARTER: 'starter',
  PRO: 'pro',
  ENTERPRISE: 'enterprise',
};

export const API_ENDPOINTS = {
  LEADS: '/leads',
  LOGIN: "/access/login",
  REFRESH_TOKEN: "/access/refresh",
  SIGNUP: "/access/signup",
  ACCESS_ME: "/access/me",
  ACCESS_USAGE: "/access/usage",
  FORGOT_PASSWORD: "/access/forgot-password",
  RESET_PASSWORD: "/access/reset-password",
  VERIFY_EMAIL : "/access/verify-email",
  RESEND_VERIFICATION_CODE : "/access/resend-verification-code",
  CONNECTIONS: "/connections/",
  GOOGLE_OAUTH_START: "/connections/oauth/start_google",
  CREATE_SMTP_CONNECTION: "/connections/create_smtp_identity_and_connection",
  CONNECTION_SET_PRIMARY: (connectionId) =>
    `/connections/${encodeURIComponent(connectionId)}/set-primary`,
  CONNECTION_BY_ID: (connectionId) =>
    `/connections/${encodeURIComponent(connectionId)}`,
  CONNECTION_TEST: (connectionId) =>
    `/connections/${encodeURIComponent(connectionId)}/test`,
  SEARCH_LEADS: "/search/search_leads",
  SEARCH_HISTORY: "/search/history",
  SEARCH_EVENTS_TICKET: "/search/events/ticket",
  SEARCH_LEADS_BY_ID: (searchId) =>
    `/search/${encodeURIComponent(searchId)}/leads`,
  NOTIFICATIONS: "/notifications",
  NOTIFICATIONS_UNREAD_COUNT: "/notifications/unread_count",
  NOTIFICATION_READ: (notificationId) =>
    `/notifications/${encodeURIComponent(notificationId)}/read`,
  NOTIFICATIONS_MARK_ALL_READ: "/notifications/mark_all_read",
  GET_ORGANIZATION_BRAND_CONTEXT: "/outreach/organization_brand_context",
  CREATE_UPDATE_ORGANIZATION_BRAND_CONTEXT: "/outreach/organization_brand_context",
  OUTREACH_PRODUCTS: "/outreach/products",
  OUTREACH_PRODUCT_BY_ID: (productId) =>
    `/outreach/products/${encodeURIComponent(productId)}`,
  OUTREACH_PRODUCT_SEQUENCE_COUNT: (productId) =>
    `/outreach/products/${encodeURIComponent(productId)}/sequences/count`,
  OUTREACH_PRODUCT_SEQUENCES: (productId) =>
    `/outreach/products/${encodeURIComponent(productId)}/sequences`,
  OUTREACH_SEQUENCES: "/outreach/sequences",
  OUTREACH_CAP_STATUS: "/outreach/sequences/cap-status",
  OUTREACH_STATUS_GUARD: "/outreach/campaigns/status-guard",
  UPDATE_CAMPAIGN_CONTEXT: (sequenceId) =>
    `/outreach/sequences/${encodeURIComponent(sequenceId)}/context`,
  UPDATE_CAMPAIGN_STATUS: (sequenceId) =>
    `/outreach/sequences/${encodeURIComponent(sequenceId)}/status`,
  OUTREACH_BLUEPRINT_PREVIEW: "/outreach/sequences/blueprint/preview",
  OUTREACH_BLUEPRINT_APPROVE: "/outreach/sequences/blueprint/approve",
  OUTREACH_SEQUENCE_DASHBOARD: "/outreach/sequences/dashboard/summary",
  // LGS-008 T9 — unsubscribe flow (MVP-1, 2026-10-17). The FE
  // /unsubscribe/:orgId/:leadId page calls this on mount. The BE
  // route is `GET /telemetry/unsubscribe/{organization_id}/{lead_id}`
  // (sales_agentic-ai-middleware/middleware_core/app/api/telemetry/router.py).
  // In production, axios baseURL is "/api", so this resolves to
  // /api/telemetry/unsubscribe/... — nginx /api/ strip forwards to
  // the BE on 127.0.0.1:8000.
  UNSUBSCRIBE: (orgId, leadId) =>
    `/telemetry/unsubscribe/${encodeURIComponent(orgId)}/${encodeURIComponent(leadId)}`,
};

export const ROUTES = {
  LANDING_PAGE: '/',
  HOME: "/home",
  LOGIN: '/login',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: "/forgot-password",
  RESET_PASSWORD: "/access/reset-password",
  VERIFY_EMAIL: "/verify-email",
  DASHBOARD: '/dashboard',
  SEARCH: '/search',
  PRODUCTS: '/products',
  CAMPAIGNS: '/campaigns',
  CONNECTIONS: '/connections',
  GUIDES: "/guides",
  PROFILE: '/profile',
  MANAGE_SUBSCRIPTION: "/manage-subscription",
  ORGANIZATION_CONTEXT: '/organization-context',
  // LGS-008 T9 — React-side unsubscribe confirmation page. Pattern
  // format, NOT a fixed path — react-router-dom resolves this
  // against <Route path={ROUTES.UNSUBSCRIBE_PATTERN}>.
  // (2026-10-17)
  UNSUBSCRIBE_PATTERN: "/unsubscribe/:orgId/:leadId",
};
